import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { App } from './app/App';
import { AuthProvider } from './auth/AuthProvider';
import { discardStaleOidcState } from './auth/oidc';
import { queryClient } from './app/queryClient';
import { ToastProvider } from './components/ui';
import './index.css';

// Antes de montar nada: si el proveedor de identidad cambio desde la ultima
// visita, el estado OIDC guardado apunta a un realm que ya no existe.
discardStaleOidcState();

const container = document.getElementById('root');
if (!container) {
  throw new Error('No se encontro el elemento #root');
}

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <QueryClientProvider client={queryClient}>
          <ToastProvider>
            <App />
          </ToastProvider>
        </QueryClientProvider>
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
);
